import React, { ReactElement, Component } from 'react';
import style from './app.module.css';
import {
  getHomechargeOrders,
  getAfterOrder,
  getPrivatePlieInfo
} from '../../../../api/filling-pile';
import { getLoginInfoPromise, formateDatePile, go2LoginIfNot, goToPage } from '../../../../utils/common';
import FullLoading from '../../../../components/full-loading';
import emptyStatus from '@assets/emptyStatus.png';
import Toast from '@xpeng/rc-toast';

interface State {
  uid: string;
  orderList: any[];
  afterOrderList: any[];
  privatePileNo: any;
}
interface Props {
  history: {
    push: Function;
    replace: Function;
  };
}

class ServiceList extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      uid: '',
      orderList: [],
      afterOrderList: [],
      privatePileNo: '',
    };
  }
  //判断家充桩的来源
  judgeSource = item => {
    if (item.createSource === 0) {
      return `家充桩`;
    }
    if (item.createSource === 1) {
      return `随二手车购买的家桩`;
    }
    if (item.createSource === 2) {
      return `随车购买的家桩`;
    }
    if (item.createSource === 3) {
      return `商城购买的家桩`;
    }
  };
  showDate = time => {
    const res = formateDatePile(time).split(' ')[0];
    return res;
  };
  showAfterSalesDate = time => {
    const date = formateDatePile(time);
    return date;
  }
  //根据订单状态显示判断字体颜色
  judgeColor = item => {
    if (
      item.orderStatusStr === '已完成' ||
      item.orderStatusStr === '中途结束'
    ) {
      return style.compeleted;
    }
    if (item.orderStatusStr === '待确认维修结果') {
      return style.confirmRes;
    }
    return style.status;
  };
  judgeColorAfter = orderStatusStr => {
    if (orderStatusStr === '已完成' || orderStatusStr === '中途结束') {
      return style.compeleted;
    }
    if (orderStatusStr === '待确认维修结果') {
      return style.confirmRes;
    }
    return style.status;
  };
  //判断售后订单状态
  judgeStatus = item => {
    if (item.orderStatus >= 1 && item.orderStatus <= 3) {
      return '待维修';
    }
    if (item.orderStatus === 4) {
      return '待确认维修结果';
    }
    if (item.orderStatus >= 5 && item.orderStatus <= 7) {
      return '已完成';
    }
    if (item.orderStatus === 8) {
      return '中途结束';
    }
  };

  gotoAfterSales = (e, item) => {
    window.location.href = item.url;
  };

  getUserInfo(res) {
    getHomechargeOrders({ uid: res.uid.toString(), type: 0 }).then(res => {
      console.log('getHomechargeOrders',res.data);
      FullLoading.hide();
      this.setState({ orderList: [...res.data] });
    })
      .catch(err => {
        console.log('安装工单err', err);
        FullLoading.hide();
      });
    getPrivatePlieInfo().then(info => {
      if(!info.piles[0]?.equipNo) return
      console.log('getPrivatePlieInfo', info.piles[0]?.equipNo);
      this.setState({ privatePileNo: info.piles[0]?.equipNo });
      getAfterOrder({ privatePileNo: info.piles[0]?.equipNo }).then(res => {
        FullLoading.hide();
        console.log('getAfterOrder',res);
        if (res.data) {
          this.setState({ afterOrderList: [...res.data.result] });
        }
      })
        .catch(err => {
          console.log('售后工单err', err);
          FullLoading.hide();
        });
    })
      .catch(error => {
        console.log('error', error)
        FullLoading.hide()
      })

  }

  componentDidMount() {
    this.setTitle();
    go2LoginIfNot().then(res => {
      FullLoading.show({
        text: '加载中'
      });
      console.log('go2LoginIfNot-------', res);
      if (!res) {
        FullLoading.hide();
        Toast.show('请先登录')
      } else if (res && res.uid) {
        this.getUserInfo(res);
      } else {
        getLoginInfoPromise().then(res => {
          const uid = res.uid.toString();
          this.setState({ uid: uid });
          this.getUserInfo(res);
        })
      }

    })
      .catch(err => {
        console.log(err);
        FullLoading.hide();
      })

  }

  setTitle = () => {
    document.title = '家充服务记录';
  };

  render(): ReactElement {
    return (
      <div className={style.wrap}>
        {this.state.afterOrderList && (this.state.orderList.length === 0 && this.state.afterOrderList.length === 0) ? (
          <div className={style.emptyBox}>
            <img src={emptyStatus} alt="" className={style.emptyBoxImg} />
            <div className={style.emptyBoxTitle}>暂无内容</div>
          </div>
        ) : (
          <div className={style.content}>
            {this.state.orderList &&
              this.state.orderList.map((item, index) => {
                return (
                  <div className={style.serviceItem} key={index}>
                    <div className={style.serviceTitle}>
                      <div className={style.title}>{this.judgeSource(item)}</div>
                      <div className={this.judgeColor(item)}>
                        {item.orderStatusStr}
                      </div>
                    </div>
                    <div className={style.time}>
                      购买时间：{this.showDate(item.createTime)}
                    </div>
                    {item.orderNo && (
                      <div className={style.orderNo}>工单号：{item.orderNo}</div>
                    )}
                    <div className={style.btnBox}>
                      {item.orderStatusStr === '待报装' ? (
                        <button
                          className={style.btn}
                          onClick={() => goToPage(item.url)}
                        >
                          预约报装
                        </button>
                      ) : (
                        <button
                          className={style.btnDetail}
                          onClick={() => goToPage(item.url)}
                        >
                          查看详情
                        </button>
                      )}
                    </div>
                  </div>
                );
              })}
            {this.state.afterOrderList &&
              this.state.afterOrderList.map((itm, idx) => (
                <div className={style.serviceItem} key={idx}>
                  <div className={style.serviceTitle}>
                    <div className={style.title}>家充售后服务</div>
                    <div className={this.judgeColorAfter(this.judgeStatus(itm))}>
                      {this.judgeStatus(itm)}
                    </div>
                  </div>
                  <div className={style.time}>
                    申请时间：{this.showAfterSalesDate(itm.createTime)}
                  </div>
                  {itm.orderNo && (
                    <div className={style.orderNo}>工单号：{itm.orderNo}</div>
                  )}
                  <div className={style.btnBox}>
                    <button
                      className={style.btnDetail}
                      onClick={e => this.gotoAfterSales(e, itm)}
                    >
                      查看详情
                    </button>
                  </div>
                </div>
              ))}
          </div>
        )}
      </div>
    );
  }
}

export default ServiceList;
